import React from 'react'
import Address from '../components/Address';
//import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Addresspage = () => {
  return (
    <div>
      
      <Address/>
      <Footer/>
    </div>
  )
}

export default Addresspage
